import React from 'react';
import StatisticsRow, {
  StatisticItem,
} from '../../../components/global/data-display/StatisticsRow';

export type { StatisticItem };

interface StatisticsSummaryProps {
  title?: string;
  stats: StatisticItem[];
}

const StatisticsSummary: React.FC<StatisticsSummaryProps> = ({ title, stats }) => {
  return <StatisticsRow title={title} stats={stats} variant="whiteOnGrey" />;
};

export default StatisticsSummary;
